import { createContext, use } from 'react';

/** Ids of tasks waiting on an unfinished blocker, for the "blocked" mark on rows and cards. */
export const BlockedContext = createContext<ReadonlySet<string>>(new Set());

export function useIsBlocked(taskId: string): boolean {
  return use(BlockedContext).has(taskId);
}
